import { all, put, takeEvery } from 'redux-saga/effects';

import { SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_SUCCESS } from '@app/store/actionTypes';
import { recordGTMEvent, recordPixelCustomEvent } from '@app/store/analytics/actions';
import FacebookPixelCustomEventName from '@app/store/analytics/FacebookPixelCustomEventName';
import { fetchSigningRequestCountSuccess } from '@app/store/softLanding/actions';

export function* handleFirstSigningRequestCompleted(
  action: ReturnType<typeof fetchSigningRequestCountSuccess>
) {
  if (action.payload === 1) {
    yield put(recordPixelCustomEvent(FacebookPixelCustomEventName.FIRST_SIGNING_REQUEST_COMPLETED));
    yield put(recordGTMEvent('firstSigningRequested'));
  }
}

export default function* sagas() {
  yield all([
    takeEvery(
      SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_SUCCESS,
      handleFirstSigningRequestCompleted
    ),
  ]);
}
